import { useEffect, useState } from "react";
import { ContractEffectsTableData, TotalsData } from "../types";
import ContractEffectsQueryService from "./contractEffectsQueryService";
import { Container } from "../styles";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { T2 } from "../../../styles/titles";
import { FormFilter } from "./components/filter/filters";
import { Totals } from "./components/totals/totals";
import LiveTable from "./components/liveTable/liveTable";

const ContractEffectsQuery: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filterData, setFilterData] = useState<any>(null);
  const [tableData, setTableData] = useState<ContractEffectsTableData>({
    records: [],
    count: 0,
  });
  const [totals, setTotals] = useState<TotalsData>({
    totalUrValue: 0,
    totalClientValue: 0,
    totalCreditorValue: 0,
  });
  const contractEffectsService = new ContractEffectsQueryService();

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const data = await contractEffectsService.getContracts(
        currentPage,
        pageSize,
        filterData,
      );
      setTotals({
        totalUrValue: data.sumUrValue,
        totalClientValue: data.sumClientTransferredValue,
        totalCreditorValue: data.sumCreditorTransferredValue,
      });
      setTableData({
        records: data.queryable || [],
        count: data.rowCount || 0,
      });
    } catch (error) {
      console.error("Erro ao buscar nos dados: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (filterData) {
      setCurrentPage(1);
    }
  }, [filterData]);

  useEffect(() => {
    if (filterData) {
      fetchData();
    }
  }, [filterData, currentPage, pageSize]);

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />

      <T2>Consulta de Efeitos</T2>
      <Totals data={totals} />
      <FormFilter getFilters={(data) => setFilterData(data)} />
      <LiveTable
        data={tableData}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
      ></LiveTable>
    </Container>
  );
};

export default ContractEffectsQuery;
